<template>
  <Modal :id="id" title="Prerequisites Not Met">
    <div slot="body" class="modal-body">
      <div class="row">
        <div class="col-12">
          <div class="alert alert-info">
            The prerequisite course(s) must be completed prior to being granted access to launch this course.
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-info" href="#" @click.prevent="close">Close</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "prerequisite-notice-modal",
    };
  },
};
</script>